import React from "react";
import BottomTabButtons from "./BottomTabButtons";

function BottomTab({ title, count, onPageChange }: any) {
  return (
    <div className="flex items-center justify-between px-4 py-3 bg-slate-50/50">
      <span className="text-sm text-slate-600">
        <span className="font-semibold text-slate-800">{count}</span> {title ?? "items"}
      </span>
      <BottomTabButtons rows={count} onPageChange={onPageChange} />
    </div>
  );
}

export default BottomTab;
